import React from 'react';
import Component from '@vfuk/core-accordion';
const Accordion = props => {
    return React.createElement(Component, Object.assign({}, props));
};
export default Accordion;
